
import bugsnag from '@bugsnag/js'
window.bugsnagClient = bugsnag({
        apiKey: '82b79dfb75e3bb7148eb2febe7a2c999',
        releaseStage: 'staging',
        notifyReleaseStages: ['development', 'staging', 'production'],
        collectUserIp: false,
    }
)
